





















import {Vue, Component} from 'vue-property-decorator';
import { State, namespace, Action } from 'vuex-class';
import App from './App.vue';
import { UserState } from '@/store/user/types';

const userModule = namespace('User');

const notice = { // DB 통해서 처리할 수 있도록 변경하면 좋을 듯 함.
    message: '', //'기존 애드서버 페이지와 사용상 차이가 있으니, 이점 참고해주시기 바랍니다.',
    title: '', // 본 페이지는 베타버전입니다.',
    type: '', // 'warning',
};
@Component<AppWrapper>({
    name: 'AppWrapper',
    components: {
        App,
    }
})
export default class AppWrapper extends Vue {
    private notice: {message: string, type: string} = notice;
    private pageLoaded: boolean = false;
    @userModule.State((state: UserState) => state.noticeClosed) private noticeClosed!: boolean;
    @userModule.Action('CLOSE_WELCOME_NOTICE') private closeWelcomeNotice!: any;

    @userModule.Getter('IS_LOGIN') private isLogin!: any;
    @userModule.Getter('IS_CUSTOMER_INFO_SETTED') private isCustomerInfoSetted!: boolean;

    private closeAlert() {
        try {
            this.closeWelcomeNotice()
        } catch (err) {
            throw err;
        }
    }
    private mounted() {
        this.pageLoaded = true;
    }
}
